module.exports = __webpack_public_path__ + "static/media/G1-6-Emilly-Makris-cod26.16c810f1.png";